<script setup>
definePageMeta({
  layout: 'dashboard',
  middleware: 'auth',
  ssr: false,
})

useHead({
  title: 'Om cookies',
})
</script>

<template>
  <div class="dashboard-stack">
    <div class="dashboard-header">
      <div class="dashboard-header__titles">
        <h1 class="dashboard-page__title">Information om cookies</h1>
        <p class="dashboard-page__subtitle lp-body">
          Här beskriver vi hur Automatisera Mera använder cookies och liknande tekniker.
        </p>
      </div>
    </div>

    <AppCard>
      <div class="lp-body">
        <p>
          Här informerar vi om hur denna Automatisera Mera applikation använder cookies och
          liknande tekniker i enlighet med dataskyddsförordningen (GDPR) och
          lagen om elektronisk kommunikation.
        </p>

        <h3>Vad är cookies?</h3>
        <p>
          Cookies är små textfiler som lagras lokalt i din webbläsare när du
          besöker en webbplats. De används för att webbplatsen ska fungera
          tekniskt, samt för att komma ihåg dina val och inställningar.
          Cookies kan vara antingen sessionscookies (som raderas när du
          stänger webbläsaren) eller permanenta cookies (som sparas under en
          längre tid).
        </p>

        <h3>Syfte med vår användning av cookies</h3>
        <p>
          I denna applikation använder Automatisera Mera cookies uteslutande för att säkerställa
          tjänstens grundläggande funktionalitet och säkerhet. Cookies
          möjliggör autentisering och session management så att du kan förbli
          inloggad under ditt besök. De används även för säkerhetsåtgärder,
          bland annat för att förhindra cross-site request forgery-attacker
          (CSRF-skydd). Vi använder inte cookies för marknadsföring,
          beteendeanalys, profilering eller tredjepartsspårning.
        </p>

        <h3>Förstaparts- och tredjepartscookies</h3>
        <p>
          Förstapartscookies sätts direkt av den webbplats du besöker
          (bga.automatiseramera.se) och kan endast läsas av denna webbplats.
          Tredjepartscookies sätts av externa tjänsteleverantörer, såsom
          analysverktyg, annonsnätverk eller sociala medier, via innehåll som
          laddas in på webbplatsen. Automatisera Mera använder enbart
          förstapartscookies som är tekniskt nödvändiga för tjänstens
          funktion i denna applikation.
        </p>

        <h3>Vilka cookies använder vi?</h3>
        <p>
          Automatisera Mera använder i denna applikation två förstapartscookies som är tekniskt
          nödvändiga: (1) En sessionscookie som upprätthåller din
          autentisering och håller dig inloggad under hela din session. (2) En
          CSRF-skyddscookie som förhindrar obehörig användning och
          säkerställer att förfrågningar till tjänsten kommer från dig och
          inte från tredje part. Båda cookies är strikt nödvändiga för att
          tjänsten ska fungera säkert och korrekt.
        </p>

        <h3>Samtycke och dina val</h3>
        <p>
          Enligt lagen om elektronisk kommunikation krävs inte samtycke för
          cookies som är strikt nödvändiga för att tillhandahålla en tjänst
          som du uttryckligen har begärt. Eftersom Automatisera Mera enbart
          använder sådana tekniskt nödvändiga förstapartscookies i denna applikation, finns det
          för närvarande inga valfria cookies att acceptera eller neka. Om vi
          i framtiden skulle införa icke-nödvändiga cookies, exempelvis för
          analys eller marknadsföring, kommer vi att inhämta ditt samtycke
          innan dessa används, i enlighet med gällande lagstiftning.
        </p>
      </div>
    </AppCard>
  </div>
</template>